$(document).ready(function () {

    $('body').on('click', '.js-submit-form', function (e) {

        e.preventDefault();

        var button = $(this);
        var button_text = button.text();
        button.text('Please wait...');

        var form = $(this).closest('.js-form');
        var fields = form.find('input, textarea, select');

        var form_id = form.attr('data-id');

        //Validation
        var errors = [];
        var valid = true;
        var message = '';

        //Check required fields
        var response = form.checkRequiredFields();

        if (!response.valid) {
            valid = false;
            message = "<p>Please complete these required fields to continue...</p> <ul><li>" + response.empty_fields.join('</li><li>') + "</li></ul>";
            errors.push(message);
        }

        if (valid) {

            var url = "../php/ajax/form.php?action=submit-form";

            var post_data = fields.serialize() + '&form_id=' + form_id;

            $.post(url, post_data, function (data) {

                try {
                    response = JSON.parse(data);

                    if (response.success) {

                        if ($('.js-sample-dialog').length > 0) {
                            $('.js-sample-dialog').dialog().dialog('close');
                            $('.ui-widget-overlay').remove();
                        }

                        dialogify('<h2>Thank you</h2><p>Thank you for your form submission, we will be in touch with you in due course.</p>');
                        fields.not('[type=hidden]').val('');
                        button.text(button_text);
                    } else {

                        message = response.errors.join('<br />');
                        dialogify(message);
                        button.text(button_text);
                    }
                } catch (e) {
                    dialogify(e + '<br /><hr /><br />' + data);
                    button.text(button_text);
                }

            });
        } else {
            //If errors happened tell the user
            if (!valid) {
                message = errors.join('<br />');
                dialogify(message);
                button.text(button_text);
            }
        }


    });

});